// extracted by mini-css-extract-plugin
export default {"container":"Questionnaire_container__VqcLn","feedBackScroll":"Questionnaire_feedBackScroll__zM9q1"};